import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { API_URL } from '../api';

export default function CertificateVerify() {
  const { code } = useParams();
  const [certificate, setCertificate] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/learning/certificates/verify/${encodeURIComponent(code)}`)
      .then(async (response) => {
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.detail || 'Certificado no encontrado');
        return data;
      })
      .then(setCertificate)
      .catch((reason) => setError(reason.message));
  }, [code]);

  return (
    <main className="certificate-verify-page">
      <div className="certificate-verify-card">
        <div className="forge-section-eyebrow">Verificación pública</div>
        {error ? (
          <><h1>Credencial no válida</h1><p>{error}</p></>
        ) : certificate ? (
          <>
            <div className="certificate-check">✓</div>
            <h1>Certificación FORGE verificada</h1>
            <p><strong>@{certificate.username}</strong> completó el tronco común FORGE.</p>
            <dl>
              <div><dt>Versión</dt><dd>{certificate.curriculum_version}</dd></div>
              <div><dt>Emitida</dt><dd>{new Date(certificate.issued_at).toLocaleDateString('es-MX')}</dd></div>
              <div><dt>Estado</dt><dd>{certificate.is_current ? 'Versión vigente' : 'Certificado histórico'}</dd></div>
              <div><dt>Código</dt><dd>{certificate.verification_code}</dd></div>
            </dl>
          </>
        ) : <><h1>Verificando credencial…</h1><p>Consultando evidencia de certificación.</p></>}
        <Link to="/" className="forge-button">Volver a FORGE</Link>
      </div>
    </main>
  );
}
